import { Box, getDataProps } from "@stenajs-webui/core";
import * as React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import stenaShipAnimation from "../../../animations/generated/StenaShipAnimation.lottie";

export interface ScreenSpinnerProps {}

export const ScreenSpinner: React.FC<ScreenSpinnerProps> = ({ ...rest }) => {
  return (
    <Box
      justifyContent={"center"}
      alignItems={"center"}
      spacing={6}
      {...getDataProps(rest)}
    >
      <DotLottieReact
        src={stenaShipAnimation}
        loop
        autoplay
        style={{ width: "200px", height: "200px" }}
      />
    </Box>
  );
};
